import { render, staticRenderFns } from "./EditStaffBox.vue?vue&type=template&id=39c534ef&scoped=true"
import script from "./EditStaffBox.vue?vue&type=script&lang=js"
export * from "./EditStaffBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c534ef",
  null
  
)

export default component.exports